module.exports = __webpack_public_path__ + "static/media/helvetia_logo_en.cd694d9b.svg";